module.exports = __webpack_public_path__ + "img/symptom.52d0468.svg";